import {SetGetListHistory } from './thunk/setGetListHistory';
import {SetGetListAdmin} from './thunk/setGetListAdmin';
import {SetGetListEvents} from './thunk/setGetListEvents';

export const Thunks = {
    SetGetListAdmin,
    SetGetListEvents,
    SetGetListHistory
}